import script from "./ServiceIconWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceIconWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ServiceIconWrapper.vue?vue&type=style&index=0&id=90c435f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c435f2"]])

export default __exports__